// Function to save the viewed product
const saveViewedProduct = () => {
  // Destructure product data from the global `window` object
  const { id, title, url, image, variant } = window.productData || {};

  // Check if the variant and required product data are valid
  if (!variant || !id || id === '' || !title || title === '' || !url || url === '' || !image || image === '') {
    return;
  }

  // Construct the product object
  const product = {
    id,
    title,
    url,
    image, // Main product image
    color: variant.options[0] || 'Unknown Color',
    price: (variant.price / 100).toFixed(2) // Format price to show two decimal points
  };

  // Ensure all necessary fields are present and valid
  if (!product.id || product.id === 'null' || !product.title || product.title === 'null' || !product.url || product.url === 'null' || !product.image || product.image === 'null') {
    return;
  }

  const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
  const existingProductIndex = 
  recentlyViewed.findIndex(item => item.id === product.id);

  // Remove the product if it already exists in the array
  if (existingProductIndex > -1) {
    recentlyViewed.splice(existingProductIndex, 1);
  }

  // Add the current product to the beginning of the array
  recentlyViewed.unshift(product);

  // Limit the array to a maximum of 5 items
  if (recentlyViewed.length > 5) {
    recentlyViewed.pop();
  }

  localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
  
   // Trigger a custom event after updating local storage
   window.dispatchEvent(new CustomEvent('recentlyViewedUpdated'));
};

// Export the function as default
export default saveViewedProduct;